import React from 'react';

export function Card({ children, className = "" }) {
  return (
    <div className={`bg-primary text-white rounded-card p-cardPadding shadow ${className}`}>
      {children}
    </div>
  );
} 